module.exports = __webpack_public_path__ + "static/media/arrow.1b4d5e26.svg";


//////////////////
// WEBPACK FOOTER
// ./src/LeftMenu/LanguageSwitch/arrow.svg
// module id = 215
// module chunks = 0